export default {
  // Alerts
  alerts: {
    // Info Alert
    info_alert: {
      title: "Няма налична информация",
      description: "IrisFE не можа да изтегли заявената информация.",
    },
  },
};
